<template>
  <div class="tariffs-calculation-location">
    <city-autocomplete
      v-model="location"
      :label="label"
      placeholder="Выберите населенный пункт"
      large
      @change="onChangeLocation"
    />
    <vz-button
      link
      class="tariffs-calculation-location-clear-btn"
      @click="onClear"
    >
      Очистить
    </vz-button>
    <div class="tariffs-calculation-location-tags mt-30">
      <vz-tag
        v-if="!modelValue.length"
        big
        text="Все города"
        variant="lt-gray"
      />
      <vz-tag
        v-for="item, index in modelValue"
        :key="index"
        big
        can-close
        :text="item.name"
        variant="lt-gray"
        @close="onRemoveTag"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'
import CityAutocomplete from '~~/components/autocomplete/city-autocomplete.vue'
import VzTag from '~~/components/ui-kit/vz-tag.vue'
import { Location } from '~~/types/types'

const emit = defineEmits([
  'update:modelValue'
])

const props = defineProps({
  // TODO: Hydration
  modelValue: {
    type: Array as PropType<Location[]>,
    default: () => []
  },
  isDispatch: {
    type: Boolean,
    default: false
  }
})

const location = ref({} as Location)

const label = computed((): string => {
  return props.isDispatch ? 'Откуда' : 'Куда'
})

function onChangeLocation(val: string, obj: Location) {
  const tmp = props.modelValue.find(item => item.guid === val)
  if (!tmp) {
    emit('update:modelValue', [...props.modelValue, obj])
  }
  location.value = {} as Location
}

function onRemoveTag(tag: string): void {
  const val = props.modelValue.filter(item => item.name !== tag)
  emit('update:modelValue', val)
}

function onClear() {
  emit('update:modelValue', [])
}
</script>
